export enum Directions {
  TOP,
  RIGHT,
  BOTTOM,
  LEFT,
}
